(function () {
    'use strict';

    angular
        .module('chilliAuth')
        .factory('ChilliTenancyService', ChilliTenancyService);

    ChilliTenancyService.$inject = ['$http', '$q', '$window', 'store', 'ChilliAuthService'];

    function ChilliTenancyService($http, $q, $window, store, ChilliAuthService) {
        var LOCAL_STORAGE_KEY_SELECTED_TENANCY_ID = 'selectedTenancyId';

        var service = {
            get selectedTenancyId() { return getSelectedTenancyId(); },
            set selectedTenancyId(tenancyId) { setSelectedTenancyId(tenancyId); },
            tenancyOptions: [],
            getTenancyOptions: getTenancyOptions
        };

        return service;

        function getSelectedTenancyId() {
            if (!ChilliAuthService.isAuthenticated) {
                return null;
            }

            var validTenancies = [];

            var idTokenPayload = ChilliAuthService.getIdTokenPayload();
            if (idTokenPayload && idTokenPayload.app_metadata && _.isArray(idTokenPayload.app_metadata.tenancies)) {
                validTenancies = idTokenPayload.app_metadata.tenancies;
            }

            var tenancyId = store.get(LOCAL_STORAGE_KEY_SELECTED_TENANCY_ID);

            if (!tenancyId || _.findIndex(validTenancies, function (o) { return o.tenantId === tenancyId; } ) === -1) {
                if (validTenancies.length > 0) {
                    tenancyId = validTenancies[0].tenantId;
                } else {
                    tenancyId = null;
                }
            }

            return tenancyId;
        }

        function setSelectedTenancyId(tenancyId) {
            store.set(LOCAL_STORAGE_KEY_SELECTED_TENANCY_ID, tenancyId);
            // *Hard* reload to clear any and all application state. Also, go to root URL to avoid "not found" errors.
            // Whether we go to dashboard, or stay on URL has been a subject of ongoing debate. Refer PBI's 903 and 1319.
            $window.location.href = '';
        }

        function getTenancyOptions() {
            return $http.get('api/tenant/').then(
                function (response) {
                    service.tenancyOptions = response.data;
                    return response.data;
                },
                function (response) {
                    return $q.reject(response);
                });
        }
    }
})();